<div class="logs-page">

  <div class="logs-header">
    <h3>Audit Logs</h3>

    <div class="actions">
      <button class="btn btn-light" (click)="clearFilters()">გასუფთავება</button>
      <button class="btn btn-primary" (click)="applyFilters()">ფილტრი</button>
    </div>
  </div>

  <!-- Filters -->
  <div class="filters">
    <div class="field">
      <label>ძებნა</label>
      <input class="input" type="text" [(ngModel)]="filters.search" placeholder="user / uri / message..." />
    </div>

    <div class="field">
      <label>Action</label>
      <input class="input" type="text" [(ngModel)]="filters.action" placeholder="create / update / delete..." />
    </div>

    <div class="field">
      <label>Entity</label>
      <input class="input" type="text" [(ngModel)]="filters.entity" placeholder="team / menu / list..." />
    </div>

    <div class="field">
      <label>Success</label>
      <select class="input" [(ngModel)]="filters.success">
        <option value="">ყველა</option>
        <option value="1">წარმატებული</option>
        <option value="0">ჩავარდა</option>
      </select>
    </div>

    <div class="field small">
      <label>Per page</label>
      <select class="input" [(ngModel)]="filters.per_page" (change)="applyFilters()">
        <option [ngValue]="10">10</option>
        <option [ngValue]="20">20</option>
        <option [ngValue]="30">30</option>
        <option [ngValue]="50">50</option>
      </select>
    </div>
  </div>

  <!-- Loading -->
  <div class="loading" *ngIf="isLoading">
    <span class="spinner"></span>
    იტვირთება...
  </div>

  <!-- Table -->
  <div class="table-wrap" *ngIf="!isLoading">
    <table class="table">
      <thead>
        <tr>
          <th>ID</th>
          <th>დრო</th>
          <th>მომხმარებელი</th>
          <th>Role</th>
          <th>Action</th>
          <th>Entity</th>
          <th>Success</th>
          <th>Status</th>
          <th>URI</th>
          <th>Message</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let l of logs">
          <td>#{{ l.id }}</td>
          <td>{{ l.created_at }}</td>
          <td>
            <div class="user">
              <div class="name">{{ l.actor_name }}</div>
              <div class="sub">{{ l.username }} • {{ l.ip }}</div>
            </div>
          </td>
          <td><span class="badge">{{ l.role || '-' }}</span></td>
          <td><span class="badge badge-dark">{{ l.action }}</span></td>
          <td>{{ l.entity }} <span class="muted" *ngIf="l.entity_id">#{{ l.entity_id }}</span></td>
          <td>
            <span class="pill ok" *ngIf="l.success">OK</span>
            <span class="pill bad" *ngIf="!l.success">FAIL</span>
          </td>
          <td class="muted">{{ l.status_code || '-' }}</td>
          <td class="mono">{{ l.method }} {{ l.uri }}</td>
          <td class="msg">{{ l.message || '-' }}</td>
        </tr>

        <tr *ngIf="logs?.length === 0">
          <td colspan="10" class="empty">ლოგები ვერ მოიძებნა</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Pagination -->
  <div class="pagination" *ngIf="pagination && pagination.last_page > 1">
    <button class="btn btn-light"
            [disabled]="pagination.current_page <= 1"
            (click)="goTo(pagination.current_page - 1)">
      წინა
    </button>

    <div class="pages">
      <button class="page"
              *ngFor="let p of [].constructor(pagination.last_page); let i = index"
              [class.active]="(i+1) === pagination.current_page"
              (click)="goTo(i+1)">
        {{ i+1 }}
      </button>
    </div>

    <button class="btn btn-light"
            [disabled]="pagination.current_page >= pagination.last_page"
            (click)="goTo(pagination.current_page + 1)">
      შემდეგი
    </button>
  </div>

</div>